export default "__VITE_ASSET__fcc42d0b__"